import clsx from "clsx";
import { Fragment } from "react";
import { RenderWhen } from "../../../../../components";

import Typography from "../../../../../components/typography/Typography";
import styles from "./threat-info.module.scss";

type Props = {
  actors?: Array<string>;
  className?: string;
  name: string;
  onClick?: () => void;
};

const formatThreatName = (name?: string) =>
  (name ?? "").split(".").map((item, index) =>
    index === 0 ? (
      item
    ) : (
      <Fragment key={item}>
        .
        <wbr />
        {item}
      </Fragment>
    )
  );

const ThreatInfo = ({ actors, className, name, onClick }: Props) => (
  <section
    data-testid="report_summary_threat_info_container"
    className={clsx(styles.threat_info, className)}
    onClick={onClick}
  >
    <RenderWhen
      condition={Boolean(name)}
      fallback={
        <Typography
          variant="h5"
          tag="span"
          className={clsx(styles.threat_info_name)}
          data-testid="report_summary_threat_info_no_threat_found"
        >
          No Threat Found
        </Typography>
      }
    >
      <Typography
        variant="h5"
        tag="span"
        className={styles.threat_info_name}
        data-testid="report_summary_threat_info_name"
      >
        {formatThreatName(name)}
      </Typography>
      <RenderWhen condition={Boolean(actors?.length)}>
        <Typography
          variant="body4"
          tag="span"
          className={clsx("overflow-ellipsis", styles.threat_info_actor)}
          data-testid="report_summary_threat_info_actor_names"
        >
          {actors?.join(", ")}
        </Typography>
      </RenderWhen>
    </RenderWhen>
  </section>
);

export default ThreatInfo;
